import React from 'react'
import { Grid, Column, actionCell, iconCell } from 'components/grid'
import { localized } from 'decorators'

export default localized(({ dataSource, metadata, onRowClick, localize, actionProps, persistor }) => {
  return (
    <Grid
        dataSource={dataSource}
        //defaultSort={[{ field: 'id', dir: 'desc' }]}
        onRowClick={onRowClick}
        persistor={persistor}>
        <Column field='id' title={localize('common.id')} width='70px' filterable={false} />
        <Column field='name' title={localize('common.name')} cell={iconCell({ icon: metadata.icon })} width='250px' />
        <Column field='city' title={localize('suppliers.city')} />
        <Column field='address' title={localize('suppliers.address')} />
        <Column field='countryName' title={localize('suppliers.country')} />
        <Column cell={actionCell({ actionProps })} width='100px' filterable={false} sortable={false} />
    </Grid>
  )
})
